<template>
  <div>
    <v-toolbar flat color="white">
      <router-link to="/" exact class="text--lighten-2">
        <img
          src="/img/logosmoll.png"
          xstyle="height: 55px;"
          style="height: 50px;"
          alt="Lokales Handwerk"
          class="mt-2"
        />
      </router-link>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list>
      <v-list-tile value="true" v-for="(item, i) in items" :key="i" :to="item.route">
        <v-list-tile-action>
          <v-icon light v-html="item.icon"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.title" style="color: #272727;"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: this.$t('nav_menu_title'),
      items: [
        { title: 'Startseite', icon: 'home', route: { name: 'startseite' }},
        { title: 'Ihr Schreibtisch', icon: 'dashboard', route: { name: 'home' }},
        // { title: 'Mein Profil', icon: 'account_box', route: { name: 'einstellungen.profil' }},
        { title: 'Mein Betrieb', icon: 'business', route: { name: 'meinbetrieb.profil' }},
        { title: 'Kundenanfragen', icon: 'inbox', route: { name: 'anfragen' }},
        { title: 'Kunden-Check', icon: 'policy', route: { name: 'kcheck' }}
        //, { title: 'Lokale Zettel', icon: 'touch_app', route: { name: 'zettel' }},
        // { title: 'Kalender', icon: 'date_range', route: { name: 'kalender' }},
        // { title: 'Stellenanzeigen', icon: 'people', route: { name: 'stellen' }},
        // { title: 'Meine Stellenanzeigen', icon: 'person_add', route: { name: 'meinestellen' }},
        // { title: 'Kunden', icon: 'people', route: { name: 'kunden' } },
        // { title: 'Austausch Forum', icon: 'forum', route: { name: 'anzeigen' }},
        // { title: 'Meine Nachrichten', icon: 'message', route: { name: 'nachrichten' }}
        //, { title: 'Pioniere', icon: 'message', route: { name: 'pionierestart' }}
        // { title: 'In der Nähe', icon: 'map', route: { name: 'indernaehe' }}
        // { title: 'Alle Betriebe', icon: 'list', route: { name: 'betriebe' } },
        // { title: 'Testland', icon: 'list', route: { name: 'testland' } },
        // { title: 'Impressum', icon: 'copyright', route: { name: 'impressum' } }
      ]
    }
  }
}
</script>